import { ModalProps } from '@chakra-ui/react';

type Modal = Omit<ModalProps, 'children' | 'id'> & {
  id: string | null;
  onNext: () => void;
  onPrev: () => void;
  disableNext: boolean;
  disablePrev: boolean;
};

export type AgentDetailsProps = Modal & {};

export enum MODE {
  DEFAULT = 'default',
  EDIT = 'edit',
}
